export enum DECIMALS {
  WEI = 18,
  YOCTO = 24,
  LAMPORT = 9,
}
